import { Stack } from "@chakra-ui/layout";
import { useAccent3 } from "src/modeAwareColors";
import { H2, H3 } from "src/typography/typography";

function TextBlock({ heading, body, ...rest }) {
  const a3 = useAccent3()
  return (
    <Stack
      spacing={4}
      maxW='380px'
      {...rest}
    >
      <H2
        as='h3'
      >
        {heading}
      </H2>
      <H3
        as='p'
        color={a3}
      >
        {body}
      </H3>
    </Stack>
  )
}

export default TextBlock
